import { render } from "./AdjustPoints.vue?vue&type=template&id=7a40eef4&ts=true"
import script from "./AdjustPoints.vue?vue&type=script&lang=ts"
export * from "./AdjustPoints.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__